import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProcessCategories } from '../../hooks/useNomenclatures';
import { useProcessCategoryMutations } from '../../hooks/useNomenclatures';
import { useNotifications } from '../NotificationSystem';
import GenericNomenclatureList from '../protocols/nomenclatures/GenericNomenclatureList';
import InitializeButton from '../protocols/nomenclatures/InitializeButton';
import './ProcessCategoryManager.css';

/**
 * Process Category Manager Component
 * Dedicated manager for Process Categories in IPC Setup
 */
const ProcessCategoryManager = () => {
  const { t } = useTranslation('ipc');
  const { items: processCategories, loading, error, refresh } = useProcessCategories(false);
  const mutations = useProcessCategoryMutations();
  const { notify } = useNotifications();

  const fields = useMemo(() => [
    { name: 'icon', label: t('icon'), type: 'text', placeholder: '🦠' },
    { name: 'color', label: t('color'), type: 'color' }
  ], [t]);

  const handleUpdate = () => {
    refresh();
    notify.success(t('processCategoriesUpdated'));
  };

  if (loading) {
    return (
      <div className="process-category-manager">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>{t('loadingProcessCategories')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="process-category-manager">
        <div className="error-state">
          <div className="error-icon">⚠</div>
          <h3>{t('errorLoadingProcessCategories')}</h3>
          <p>{error.message || error}</p>
          <button onClick={refresh} className="btn btn-secondary">{t('retry')}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="process-category-manager">
      <div className="manager-header">
        <div>
          <h2>{t('processCategories')}</h2>
          <p className="subtitle">{t('processCategoriesSubtitle')}</p>
        </div>
        <InitializeButton
        onComplete={handleUpdate}
        buttonLabel={t('initializeDefaultData')}
        initializingLabel={t('initializing')}
        modalTitle={t('initializeDefaultData')}
        modalMessage={t('initializeDefaultDataConfirm')}
        cancelLabel={t('cancel')}
        continueLabel={t('continue')}
      />
      </div>

      <GenericNomenclatureList
        items={processCategories}
        type="process-categories"
        title={t('processCategories')}
        fields={fields}
        mutations={mutations}
        onUpdate={handleUpdate}
      />
    </div>
  );
};

export default ProcessCategoryManager;

